import { useFundRequestContext } from 'BreetHooks';

import { SelectWallet } from '../SelectWallet';

const Header = () => {
	const { selectedWallet, selectWallet } = useFundRequestContext();

	return (
		<SelectWallet
			title='Which wallet do you want to fund?'
			selectDefaultWallet={selectWallet}
			selectedDefaultWallet={selectedWallet}
			type='fund'
		/>
	);
};

export default Header;
